/*
 * @Date: 2024-12-02 17:52:01
 * @Description:项目入驻申请
 */
import ProjectApplicationList from '../views/project-application-list.vue';

export const route = [
  {
    path: '/main/asp/project-application/list',
    name: 'main-asp-project-application-list',
    meta: {
      title: '项目入驻申请'
    },
    component: ProjectApplicationList
  }
];
